var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-tooltip',{attrs:{"position":"is-left","label":_vm.$t('sondage.addpropsition')}},[_c('div',{on:{"click":_vm.addProposition}},[_c('img',{staticClass:"icon",staticStyle:{"margin-left":"5px"},attrs:{"src":require("@/assets/img/icons/create.png"),"alt":"icon-drop"}})])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-047f9ab0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/question/components/AddPropositionButton.vue
// module id = null
// module chunks = 